// extracted by mini-css-extract-plugin
export default {"webpack-dev-server-client-overlay":"app_webpack-dev-server-client-overlay__RmUfM","app_body":"app_app_body__9f+05"};